import React from 'react';
import { Box } from '@mui/material';

import { State } from '../redux';
import { FormSelect } from '../../../components/FormSelect';

const eventTypes = [
  { v: 'created', c: 'Membership Created' },
  { v: 'active', c: 'Membership Active' },
  { v: 'birthday', c: 'On Membership Birthday' },
];

type ComponentState = State['emConfiguration']['membershipEvent'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};
const MembershipEventConfiguration: React.FC<Props> = (props) => {
  const { eventType, fieldDisabled } = props;

  return (
    <Box>
      <Box my={4}>
        <FormSelect
          id='eventType'
          label='Membership Event'
          options={eventTypes}
          readonly={fieldDisabled('eventType')}
          value={eventType}
        />
      </Box>
    </Box>
  );
};

export { MembershipEventConfiguration };
